import { ReactNode } from "react";
import { footerActionBarStyles } from "./sheet.css";

interface SheetFooterProps {
  footer: ReactNode;
}

const SheetFooter = ({ footer }: SheetFooterProps) => {
  return <footer className={footerActionBarStyles}>{footer}</footer>;
};

export default SheetFooter;
